import script from "./documentCategorize.vue?vue&type=script&lang=ts&setup=true"
export * from "./documentCategorize.vue?vue&type=script&lang=ts&setup=true"

import "./documentCategorize.vue?vue&type=style&index=0&id=24805691&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24805691"]])

export default __exports__